import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["changeSource"]

  connect() {
    this.handleSelect2Events()
  }

  businessEntityDidChange() {
    this.changeSourceTarget.value = "business_entity"
    this.element.requestSubmit()
  }

  billingInformationDidChange() {
    this.changeSourceTarget.value = "billing_information"
    this.element.requestSubmit()
  }

  // Translate Select2 jQuery events into native DOM events
  handleSelect2Events() {
    $(this.element).on("select2:select select2:unselect", function(e) {
      e.target.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
